/**
 * package: com.inq.stage
 * class: Move
 * @extends com.inq.stage.DragResize 
 * @constructor
 */
com.inq.stage.Move = function() {
	com.inq.stage.DragResize.call(this);
	this.className = "Move";
	this.cursor = "move";
};
$hxClasses['com.inq.stage.Move'] = com.inq.stage.Move;
/** @private @type {Array} */
com.inq.stage.Move.__name__ = ["com","inq","stage","Move"];
/** @private @type {Function} */
com.inq.stage.Move.__super__ = com.inq.stage.DragResize;
for(var k in com.inq.stage.DragResize.prototype ) com.inq.stage.Move.prototype[k] = com.inq.stage.DragResize.prototype[k];

/**
 * setDragable
 * Replaces the "FlashPeer.setDragable
 * Sets up the chat skin for being moved around and replaces the version in the IJSF
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function setDragable():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.Move.setDragable = function() {
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow() || com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		return;
	}
	/** @type {com.inq.stage.Move} */ 
	var instance = new com.inq.stage.Move();
	var pDoc = window.parent.document;
	/** @type {Element} */ 
	var cntr = com.inq.ui.Container._getElementById("inqChatStage",pDoc);
	/** @type {Element} */ 
	var dragHandleElem = com.inq.ui.Container._getElementById("inqTitleBar",pDoc);
	instance.init(dragHandleElem,cntr);
};


/**
 * setTop
 * Move the drag image (Y-axis only)
 * drag image - this.obj
 * drag border - titlebar ;
 *
 * $type TFun([{ name => top, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * override private function setTop(top:Int)
 * @override
 * @private
 * @this com.inq.stage.Move
 * @param {number}  top 
 * @return {void}
 */
com.inq.stage.Move.prototype.setTop = function(top) {
	/** @type {Element} */
	 var o = this.obj;
	o.style.top = top + "px";
};


/**
 * setLeft
 * Move the drag image (X-axis only)
 * drag image - this.obj
 * drag border - titlebar ;
 *
 * $type TFun([{ name => left, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * override private function setLeft(left:Int)
 * @override
 * @private
 * @this com.inq.stage.Move
 * @param {number}  left 
 * @return {void}
 */
com.inq.stage.Move.prototype.setLeft = function(left) {
	this.obj.style.left = left + "px";
};


/**
 * setDragBorder creates the outside border for dragging or resizing
 * Saves the style attributes before modifiing them so that they can be resotored on mouse up
 * Used by the mouse down handler "uponDragStart"
 *
 * @override
 * @private
 * @this com.inq.stage.Move
 * @return {void}
 */
com.inq.stage.Move.prototype.setDragBorder = function() {
	/** @type {number} */ 
	var rootHeight = Std.parseInt(this.root.style.height);
	/** @type {number} */ 
	var rootWidth = Std.parseInt(this.root.style.width);
	/** @type {number} */ 
	var borderWidth = 7;
	this.obj.style.cursor = this.cursor;
	this.obj.style.borderStyle = "solid";
	this.obj.style.borderWidth = borderWidth + "px";
	this.obj.style.borderColor = com.inq.utils.Util.getConfig("dragBorderColor",com.inq.stage.DragResize.DEFAULT_BORDER_COLOR);
	
	this.obj.style.height = rootHeight - borderWidth + "px";
	this.obj.style.width = rootWidth - borderWidth + "px";
};


/**
 * whenDone is invoked following the mouse up event in uponDrop function
 * It is invoked via the setTimeout functiona and is NOT in the same thread as the
 * event handler.  This is by design so not to delay further event handling.
 *
 * $type TFun([],TEnum(Void,[]))
 * override public function whenDone ():Void
 * @override
 * @public
 * @this com.inq.stage.Move
 * @return {void}
 */
com.inq.stage.Move.prototype.whenDone = function() {
	this.root.style.left = Std.string(this.pDraggerNow.X) + "px";
	this.root.style.top = Std.string(this.pDraggerNow.Y) + "px";
	/** @type {Object} */ 
	var position = { X : this.pDraggerNow.X, Y : this.pDraggerNow.Y};
	Application.MoveStage(position.X,position.Y);

	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	Application.initialXPos = position.X-vp.x;
	Application.initialYPos = position.Y-vp.y;
};


/**
 * getDefaultMax
 * getDefaultMin - get the minimum size {x, y} coordinates for the drag move
 * For the drag move it is the bottom right corner of the visible document minus the chat window width and height
 *
 * $type TFun([],TDynamic(null))
 * override private function getDefaultMax():Dynamic
 * @override
 * @private
 * @this com.inq.stage.Move
 * @return {Object} -  JSON
 */
com.inq.stage.Move.prototype.getDefaultMax = function() {
	/** @type {number} */ 
	var width = Std.parseInt(this.root.style.width);
	/** @type {number} */ 
	var height = Std.parseInt(this.root.style.height);
	return { X : com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollWidth() - width, Y : com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollHeight() - height};
};


/**
 * getDefaultMin - get the minimum size {x, y} coordinates for the drag move
 * For the drag move it is the top left corner of the visible document
 *
 * $type TFun([],TDynamic(null))
 * override private function getDefaultMin():Dynamic
 * @override
 * @private
 * @this com.inq.stage.Move
 * @return {null} -  JSON
 */
com.inq.stage.Move.prototype.getDefaultMin = function() {
	return { X : com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft(), Y : com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop()};
};

/** @type {com.inq.stage.Move} */
com.inq.stage.Move.prototype.__class__ = com.inq.stage.Move;
com.inq.stage.Move.__interfaces__ = [com.inq.stage.IDragResize];
